import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { getCurrentUser } from '@/api/user/userService'
import { useAuth } from '@/context/AuthContext'
import { QUERY_KEYS } from '@/lib/queryKeys'

export const useCurrentUser = () => {
  const { isAuthenticated } = useAuth()

  return useQuery({
    queryKey: [QUERY_KEYS.LOGGED_USER],
    enabled: isAuthenticated,
    select: data => ({ ...(data || {}), permissions: data.permissions || {} }),
    queryFn: () => getCurrentUser(),
    retry(failureCount, error) {
      // Dont retry if the error is 401 or 403
      if (error instanceof AxiosError && (error.response?.status === 401 || error.response?.status === 403)) {
        return false
      }
      return failureCount < 2
    },
  })
}
